(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfNSolverMissing', [
    function() {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: (function(_this) {
          return function($scope, element, attrs, ctrl) {
            var fieldSurvey, findInParent, inputConfig, inputName, match, ref;
            findInParent = function($scope, key) {
              if ($scope[key] != null) {
                return $scope[key];
              }
              return findInParent($scope.parent, key);
            };
            inputConfig = findInParent($scope, 'inputConfig');
            if (!inputConfig) {
              throw Error("N Solver red validation: Could not find inputConfig in any parent scope for ng-model " + attrs.ngModel);
            }
            if (((ref = inputConfig.value.required) != null ? ref.value : void 0) !== true) {
              return;
            }
            if (element.hasClass('ui-select-container')) {
              element = element.find('a.ui-select-match');
            }
            if (match = attrs.ngModel.match(/\[([^\]]+)\]$/)) {
              match = match[1];
              if (match = match.match(/^['"](.*)['"]$/)) {
                inputName = match[1];
              } else {
                inputName = $scope.$parent.inputName;
              }
            } else {
              if (match = attrs.ngModel.match(/\.([^\.]+)$/)) {
                inputName = match[1];
              }
            }
            if (!inputName) {
              throw Error("N Solver red validation: Could not find input name for ng-model " + attrs.ngModel);
            }
            fieldSurvey = findInParent($scope, 'fieldSurvey');
            if (!fieldSurvey) {
              throw Error("N Solver red validation: Could not find fieldSurvey in any parent scope for ng-model " + attrs.ngModel);
            }
            if ($scope.service.nextAttempted && !$scope.service.inputComplete(inputName, fieldSurvey)) {
              element.addClass('mfvalidate-invalid');
            }
            return $scope.$watchGroup([attrs.ngModel, attrs.mfNSolverMissing, 'service.nextAttempted'], function() {
              if ($scope.service.inputComplete(inputName, fieldSurvey)) {
                return element.removeClass('mfvalidate-invalid');
              } else if ($scope.service.nextAttempted) {
                return element.addClass('mfvalidate-invalid');
              }
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
